/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro Timer — Free 25 Minute Focus Timer | Toolverse`)
};

const es_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Pomodoro — Sesión de Enfoque Gratis de 25 Minutos | Toolverse`)
};

const de_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro-Timer — Kostenloser 25-Minuten-Fokus-Timer | Toolverse`)
};

const nl_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro Timer — Gratis 25 Minuten Focustimer | Toolverse`)
};

const fr_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuteur Pomodoro — Minuteur de concentration gratuit de 25 minutes | Toolverse`)
};

const it_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer Pomodoro — Sessione di Concentrazione Gratuita da 25 Minuti | Toolverse`)
};

const pt_br2_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Pomodoro — Foco Grátis de 25 Minutos | Toolverse`)
};

const pt_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Pomodoro — Sessão de Foco Gratuita de 25 Minutos | Toolverse`)
};

const ja_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポモドーロタイマー — 無料の25分集中タイマー | Toolverse`)
};

const zh_timer_pomodoro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`番茄钟 — 免费25分钟专注计时器 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_meta_title", locale)
	if (locale === "en") return en_timer_pomodoro_meta_title(inputs)
	if (locale === "es") return es_timer_pomodoro_meta_title(inputs)
	if (locale === "de") return de_timer_pomodoro_meta_title(inputs)
	if (locale === "nl") return nl_timer_pomodoro_meta_title(inputs)
	if (locale === "fr") return fr_timer_pomodoro_meta_title(inputs)
	if (locale === "it") return it_timer_pomodoro_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_meta_title(inputs)
	if (locale === "pt") return pt_timer_pomodoro_meta_title(inputs)
	if (locale === "ja") return ja_timer_pomodoro_meta_title(inputs)
	return zh_timer_pomodoro_meta_title(inputs)
};